import React, { useState } from 'react';

const CollapseComponent = ({ collapseName, indexName, collapseBody, collapseHead }) => {
    return (
        <div key={`${collapseName}_${indexName}`} className="accordion">
            <div className="accordion-head">
                <h6 className="ui-accordion-header" style={{lineHeight: "2"}}>
                    {collapseHead}
                </h6>
            </div>
            <div className="collapse accordion-body ui-accordion-content" id={`collapseExample_${indexName}`}>
                <div className="pd-t-20">{collapseBody}</div>
            </div>
        </div>
    )
}

export default CollapseComponent;